<template>
    <div>
        <b-navbar toggleable="lg">
            <b-navbar-brand>
                <span v-for="step in steps" :key="step.id" v-if="step.id-1 === currentStep">
                    <i v-bind:class="[step.icon, 'fa']"></i>
                    <span v-if="$store.state.registration.newUser ">
                        Stap {{step.id}} van {{steps.length}}
                    </span>
                    <span v-else>
                        {{step.text}}
                    </span>
                </span>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <template v-for="step in steps">
                        <b-nav-item @click="onClick(step)" :disabled="$store.state.registration.newUser && step.id-1 >= currentStep" :key="step.id">
                            <i v-bind:class="[step.icon, 'fal', 'fax']"></i>
                            <span v-if="$store.state.registration.newUser">
                                Stap {{step.id}} - {{step.text}}
                                <i v-if="step.id-1 < currentStep" class="fa fax fa-check"></i>
                            </span>
                            <span v-else>
                                {{step.text}}
                            </span>
                        </b-nav-item>
                    </template>
                    <b-nav-item  v-on:click="backToOld('/woningaanbod')">
                      <i class="fal fax fa-home"></i>
                      <span>
                        Woningaanbod
                      </span>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>
<script>
export default {
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: []
    },
  },
    methods: {
        onClick(step) {
            if(!this.$store.state.registration.newUser || step.id-1 < this.currentStep) {
                this.$emit('goToStep', step.id-1)
            } else {
                return false
            }
        },
        backToOld(path) {
          window.location.href = path;
        },
    }
}
</script>
<style lang="scss" scoped>
.header {
  padding-top: 10px;
}
</style>